import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la sensación",
    opening: localizedGenderNode(
      [
      "Hoy no intento arreglarme.",
      "Solo noto: hay una sensación de no pertenecer en mi."
    ],
      [
      "Hoy no intento arreglarme.",
      "Solo noto: hay una sensación de no pertenecer en mi."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando es más fuerte esta sensación?",
      "Que sube en mi junto a ella?",
      "Que frase interna se repite?"
    ],
      [
      "Cuando es más fuerte esta sensación?",
      "Que sube en mi junto a ella?",
      "Que frase interna se repite?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una sensación es una experiencia, no una identidad."
    ],
      [
      "Una sensación es una experiencia, no una identidad."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Veo la sensación\".",
      "una respiracion + \"Veo la sensación\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El momento en que aparece",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que sube la sensación.",
      "Solo noto."
    ],
      [
      "Hoy noto el momento en que sube la sensación.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa justo antes de que suba?",
      "Quien esta alrededor cuando aparece?",
      "Que temo que pase ahi?"
    ],
      [
      "Que pasa justo antes de que suba?",
      "Quien esta alrededor cuando aparece?",
      "Que temo que pase ahi?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando el momento es claro, tengo un poco de espacio."
    ],
      [
      "Cuando el momento es claro, tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando sube la sensación.",
      "una respiracion cuando sube la sensación."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se sienta la sensación en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde se sienta la sensación en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta protegerme."
    ],
      [
      "Mi cuerpo intenta protegerme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el hecho desnudo aquí?",
      "Que historia salto?",
      "Que posibilidad más suave podria ser cierta?"
    ],
      [
      "Cual es el hecho desnudo aquí?",
      "Que historia salto?",
      "Que posibilidad más suave podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Mi comparacion",
    opening: localizedGenderNode(
      [
      "Hoy veo como la comparacion alimenta la sensación.",
      "Solo noto."
    ],
      [
      "Hoy veo como la comparacion alimenta la sensación.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento en silencio un momento.",
      "Una respiracion."
    ],
      [
      "Me siento en silencio un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Con quien me comparo?",
      "Que creo que me falta ahi?",
      "Que traigo conmigo?"
    ],
      [
      "Con quien me comparo?",
      "Que creo que me falta ahi?",
      "Que traigo conmigo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La comparacion es un habito, no una verdad."
    ],
      [
      "La comparacion es un habito, no una verdad."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"No tengo que compararme\".",
      "una frase interna - \"No tengo que compararme\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "La voz interna",
    opening: localizedGenderNode(
      [
      "Hoy escucho la voz que dice \"no pertenezco\".",
      "Sin pelear con ella."
    ],
      [
      "Hoy escucho la voz que dice \"no pertenezco\".",
      "Sin pelear con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como suena esa voz?",
      "Que intenta proteger?",
      "Que me gustaria decirle?"
    ],
      [
      "Como suena esa voz?",
      "Que intenta proteger?",
      "Que me gustaria decirle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz es solo una voz."
    ],
      [
      "Una voz es solo una voz."
    ]
    ),
    action: localizedGenderNode(
      "notarla sin creerla.",
      "notarla sin creerla."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La necesidad de pertenecer",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad de pertenecer.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad de pertenecer.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentir que pertenezco?",
      "Donde si me siento parte?",
      "Cual es un pequeño momento de pertenencia para mi?"
    ],
      [
      "Que necesito para sentir que pertenezco?",
      "Donde si me siento parte?",
      "Cual es un pequeño momento de pertenencia para mi?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Pertenecer es una necesidad humana."
    ],
      [
      "Pertenecer es una necesidad humana."
    ]
    ),
    action: localizedGenderNode(
      "escribir un momento en que si me senti parte.",
      "escribir un momento en que si me senti parte."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un pequeño ancla",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño ancla cuando estoy con gente.",
      "No uno grande."
    ],
      [
      "Hoy elijo un pequeño ancla cuando estoy con gente.",
      "No uno grande."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mis pies.",
      "Una respiracion."
    ],
      [
      "Siento mis pies.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me ayuda a quedarme conmigo?",
      "Que pequeño ancla es posible para mi?",
      "Como se siente cuando me quedo conmigo?"
    ],
      [
      "Que me ayuda a quedarme conmigo?",
      "Que pequeño ancla es posible para mi?",
      "Como se siente cuando me quedo conmigo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño ancla puede ser suficiente."
    ],
      [
      "Un pequeño ancla puede ser suficiente."
    ]
    ),
    action: localizedGenderNode(
      "sentir mis pies un momento.",
      "sentir mis pies un momento."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un lenguaje interno suave",
    opening: localizedGenderNode(
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ],
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como me hablo cuando siento que no pertenezco?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ],
      [
      "Como me hablo cuando siento que no pertenezco?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz suave baja la presion."
    ],
      [
      "Una voz suave baja la presion."
    ]
    ),
    action: localizedGenderNode(
      "decir la frase suave una vez.",
      "decir la frase suave una vez."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Antes de ocultarme",
    opening: localizedGenderNode(
      [
      "Hoy pauso un momento antes de cerrarme.",
      "Solo un momento."
    ],
      [
      "Hoy pauso un momento antes de cerrarme.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de esconderme.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de esconderme.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como se que me cierro?",
      "Que intento proteger ahi?",
      "Que podria ayudarme a quedarme un momento?"
    ],
      [
      "Como se que me cierro?",
      "Que intento proteger ahi?",
      "Que podria ayudarme a quedarme un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pausa pequeña cambia la historia."
    ],
      [
      "Una pausa pequeña cambia la historia."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion antes de cerrarme.",
      "una respiracion antes de cerrarme."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Volver al presente",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ],
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ],
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ],
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El presente me da suelo."
    ],
      [
      "El presente me da suelo."
    ]
    ),
    action: localizedGenderNode(
      "sentir mis pies un momento.",
      "sentir mis pies un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Un momento antes de alejarme",
    opening: localizedGenderNode(
      [
      "Hoy pauso un momento antes de alejarme.",
      "Solo un momento."
    ],
      [
      "Hoy pauso un momento antes de alejarme.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de huir.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de huir.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "De que intento alejarme?",
      "Que pasa si me quedo un momento?",
      "Que puede sostenerme en este momento?"
    ],
      [
      "De que intento alejarme?",
      "Que pasa si me quedo un momento?",
      "Que puede sostenerme en este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento pequeño cambia la direccion."
    ],
      [
      "Un momento pequeño cambia la direccion."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion antes de alejarme.",
      "una respiracion antes de alejarme."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño que me devuelve a mi.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un paso pequeño que me devuelve a mi.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ],
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que paso pequeño puede ayudarme a quedarme?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ],
      [
      "Que paso pequeño puede ayudarme a quedarme?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño basta."
    ],
      [
      "Lo pequeño basta."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño.",
      "elegir un paso pequeño."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ],
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ],
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi de esta sensación?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ],
      [
      "Que aprendi de esta sensación?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo un momento antes de responder."
    ],
      [
      "Elijo un momento antes de responder."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + mi frase.",
      "una respiracion + mi frase."
    ),
  },
].map(buildNormalizedDay);

export const feelingStrangeNotBelongBlueprintEs = buildNormalizedPilotBlueprint({
  id: "feeling_strange_not_belong_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "feeling_strange_not_belong",
  category: "anxiety",
  journeyName: {
    he: "תחושת \"אני מוזר/ה, לא שייך/ת\"",
    en: "Feeling \"I'm strange, I don't belong\"",
    es: "Sentir \"soy extrano/a, no pertenezco\"",
  },
  days,
});

export default feelingStrangeNotBelongBlueprintEs;
